export default "__VITE_ASSET__DXSe$3nK__"